import { SUPPORTED_PRODUCT_TYPES, SmartInboxFormData } from './types.ts';

export type { SmartInboxFormData, SmartInboxConfigStepProps } from './types.ts';

const DEFAULT_EVENT_CONFIG = [
    { actionKind: 'MOVE_TO_FOLDER', id: '', actionConfig: {} },
    { actionKind: 'MARK_AS_READ', id: '', actionConfig: false },
];

const DEFAULT_EVENT_CONFIGS = {
    DOCUMENT_ROUTED: [...DEFAULT_EVENT_CONFIG],
    DOCUMENT_FINISHED: [...DEFAULT_EVENT_CONFIG],
    DOCUMENT_DELETED: [...DEFAULT_EVENT_CONFIG],
    DOCUMENT_DISCARDED: [...DEFAULT_EVENT_CONFIG],
};

export const createDefaultProductConfigs = () => {
    const actionConfigs = {};

    Object.entries(DEFAULT_EVENT_CONFIGS).forEach(([eventKind, actions]) => {
        actions.forEach((action) => {
            const actionKey = `${eventKind}_${action.actionKind}`;
            actionConfigs[actionKey] = {
                eventKind,
                actionKind: action.actionKind,
                id: action.id,
                actionConfig: action.actionConfig,
            };
        });
    });

    const productConfigs = SUPPORTED_PRODUCT_TYPES.reduce(
        (acc, type) => ({
            ...acc,
            [type]: {
                documentType: type,
                channelId: null,
                actionConfigs: { ...actionConfigs },
            },
        }),
        {}
    );

    return {
        ...productConfigs,
        SMART_INBOX: {
            documentType: 'SMART_INBOX',
            channelId: null,
            actionConfigs: {
                DOCUMENT_UNMATCHED_MOVE_TO_FOLDER: {
                    eventKind: 'DOCUMENT_UNMATCHED',
                    actionKind: 'MOVE_TO_FOLDER',
                    id: '',
                    actionConfig: {},
                },
                DOCUMENT_CLASSIFIED_POST_CLASSIFY: {
                    eventKind: 'DOCUMENT_CLASSIFIED',
                    actionKind: 'POST_CLASSIFY',
                    id: '',
                    actionConfig: {
                        manual_processing_sender_emails: [],
                        manual_processing_keywords: [],
                    },
                },
            },
        },
    };
};

export const SMART_INBOX_FORM_DEFAULT_VALUES: SmartInboxFormData = {
    name: '',
    tenantId: '',
    clientId: '',
    clientSecret: '',
    mailInbox: '',
    enabled: true,
    useSmartInboxAsCreatedBy: true,
    isManualDocumentCreationEnabled: true,
    ignoreReplyAndForwardedEmails: false,
    productConfigs: createDefaultProductConfigs(),
};
